import { ACTION_TYPES, MESHBOT_NOTIFICATION } from 'constants/MeshbotConstant';
import hash from 'constants/uniqueHash';
import blockActionTemplate from '../../../../components/blockActionTemplate';
import { buildForwardNotificationsFields } from './buildForwardNotificationsFields';

export const getNotificationItems = (params, currentNotificationBlock) => {
    const { _tempId, blockOptions } = currentNotificationBlock || {};
    if (blockOptions?.method?.name === ACTION_TYPES.FORWARD_NOTIFICATIONS) {
        return [
            {
                ...currentNotificationBlock,
                _tempId: _tempId || hash(),
                fields: buildForwardNotificationsFields(params?.config, currentNotificationBlock.fields),
            },
        ];
    }

    return [blockActionTemplate(MESHBOT_NOTIFICATION, MESHBOT_NOTIFICATION, MESHBOT_NOTIFICATION, '', params, [])];
};
